var warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

export { warnOnce };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/warn-once.mjs
// module id = np4m
// module chunks = 0